import { inject, Injectable } from '@angular/core';
import { DemoType } from '@app/+onboarding/components/demo-dialog/demo-dialog.model';
import { DemoDialogService } from '@app/+onboarding/components/demo-dialog/demo-dialog.service';
import { UserGuideType } from '@app/reducers/orm/user-guide/user-guide.model';
import { SmbHospitalityOnboardingChecklistStep } from '@app/shared/onboarding/onboarding-checklist.model';
import { SbDialogService } from '@sb/ui/dialog';
import { of, switchMap, take, tap } from 'rxjs';

import { OnboardingDialogResult } from '../../../+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { OnboardingChecklistService } from '../../../shared/onboarding/onboarding-checklist.service';
import { OnboardingUtils } from '../../onboarding.utils';
import { OptimizedScheduleDialogComponent } from '../optimized-schedule/optimized-schedule-dialog.component';
import { OptimizedScheduleSummaryDialogComponent } from '../optimized-schedule/optimized-schedule-summary-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class OptimizedScheduleOnboardingService {
  private onboardingChecklist = inject(OnboardingChecklistService);
  private dialogService = inject(SbDialogService);
  private onboardingUtils = inject(OnboardingUtils);
  private demoDialogService = inject(DemoDialogService);

  openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open(OptimizedScheduleDialogComponent, { data: { originator } })
      .closed.pipe(
        take(1),
        tap((result: OnboardingDialogResult) => {
          if (!result) {
            this.onboardingUtils.stripOnboardingParamsFromRoute();
          }
        }),
      );
  }

  openDemo(skipFlow?: boolean) {
    return this.demoDialogService.openDemo(DemoType.OPTIMIZED_SCHEDULE).pipe(
      switchMap(() => {
        if (!skipFlow) {
          return this.onboardingChecklist.completeStep(
            UserGuideType.SELF_ONBOARDING_CHECKLIST,
            SmbHospitalityOnboardingChecklistStep.OPTIMIZED_SCHEDULE,
          );
        }
        return of(false);
      }),
    );
  }

  openSummary(originator: string) {
    return this.dialogService
      .setSize('xxl')
      .open(OptimizedScheduleSummaryDialogComponent, { data: { originator } })
      .closed.pipe(take(1));
  }
}
